import { Icon } from '@/src/components/ui';
import moment from 'moment';
import Link from 'next/link';
import { PartnerCheckmark } from '../../settings/components/PartnerBadge';

type Props = {
  authorId: number;
  authorName: string;
  authorImage: string;
  createdAt?: Date;
  updatedAt?: Date;
  authorUniqueLink: string;
  children?: React.ReactNode;
  isComment?: boolean;
  isPartner?: boolean;
};

export const AuthorInfo = ({
  authorId,
  authorName,
  authorImage,
  createdAt,
  updatedAt,
  authorUniqueLink,
  children,
  isComment = false,
  isPartner = false,
}: Props) => {
  const date = isComment ? createdAt : updatedAt;
  return (
    <div className="flex items-center gap-3 relative">
      <Link href={`/${authorUniqueLink}`}>
        {authorImage ? (
          <img
            src={authorImage}
            alt={authorName}
            className="w-10 h-10 rounded-full"
          />
        ) : (
          <div className="border-1 border-black rounded-full border-box size-10 p-2">
            <Icon name="follow" className="size-5.5" />
          </div>
        )}
      </Link>
      <div className="flex flex-col">
        <Link href={`/${authorUniqueLink}`}>
          <span className="text-sm md:text-base font-medium hover:underline">
            {authorName}
          </span>
          {isPartner && <PartnerCheckmark className="inline-block md:size-4 size-2" />}
        </Link>
        <span className="text-xs md:text-sm text-gray-500 font-light">
          {moment(date).fromNow()}
        </span>
      </div>
      {children}
    </div>
  );
};
